export type Appearance = {
	cover: string;
	details: string[];
	state: string;
};

const COVERS = [
	'потёртая коричневая кожа',
	'тёмная кожа с тиснением по краю',
	'выделанная кожа бехолдера с едва заметными следами глазных стеблей',
	'драконья шкура, укреплённая полосами холодного железа',
	'красная кожа с золочёным обрезом',
	'чёрная кожа, холодная на ощупь',
	'змеиная кожа, переливающаяся в свете свечи',
	'толстая бычья кожа на деревянных пластинах',
	'тёмно-синий бархат, вытертый на углах',
	'выцветшая шёлковая ткань на кожаной основе',
	'пластины слоновой кости, стянутые кожаным ремешком',
	'потемневшее красное дерево с серебряной инкрустацией',
	'грубая шкура неизвестного зверя с остатками шерсти',
	'кожа, выкрашенная в цвета школы магии, которой владеет хозяин',
	'чёрная чешуйчатая кожа',
	'белёсая кожа, жёсткая и сухая, как пергамент',
];

const DETAILS = [
	'железная застёжка с замочной скважиной',
	'серебряные уголки и тонкая цепочка вместо закладки',
	'на корешке вделан тусклый самоцвет',
	'на обложке вытиснен символ волшебной школы',
	'по краю обложки идут руны, которые невозможно прочесть',
	'к обложке приколот высушенный язык',
	'обложка перевязана кожаным шнуром с тремя узлами',
	'на обложке выжжен знак мага-владельца',
	'уголки окованы латунью',
	'вместо замка — хитрая застёжка, открывающаяся только поворотом',
	'на форзаце нарисована карта, залитая чернилами',
	'в переплёт вшит маленький локон волос',
	'пахнет сургучом и корицей',
	'пахнет серой и старым пергаментом',
	'страницы с позолоченным обрезом',
	'на корешке выцарапаны следы когтей',
	'на обложке чья-то подпись, зачёркнутая несколько раз',
	'внутри вложены сухие цветы и лисья шерсть',
];

const STATES = [
	'почти новая, страницы ещё хрустят',
	'сильно потрёпана: страницы загнуты, корешок треснул',
	'несколько страниц вырвано из переплёта',
	'страницы покрыты пятнами чернил и воска',
	'часть записей зачёркнута и переписана другим почерком',
	'в полях множество заметок мелким аккуратным почерком',
	'часть страниц склеена, словно книга побывала в воде',
	'чернила на некоторых страницах выцвели почти до нечитаемости',
	'страницы исписаны слишком плотно, поля заняты формулами',
	'бережно подшита, видно, что хозяин часто чинил её',
	'между страницами спрятан забытый клочок записки',
	'пахнет дымом: края страниц слегка опалены',
];

export const pick = <T,>(items: T[], random: () => number = Math.random): T => items[Math.floor(random() * items.length)];

export function randomAppearance(random: () => number = Math.random): Appearance {
	const details: string[] = [];
	const count = random() < 0.35 ? 1 : 2;
	while (details.length < count) {
		const detail = pick(DETAILS, random);
		if (!details.includes(detail)) details.push(detail);
	}
	return {cover: pick(COVERS, random), details, state: pick(STATES, random)};
}

export function describeAppearance({cover, details, state}: Appearance): string {
	const sentence = (text: string) => `${text.charAt(0).toUpperCase()}${text.slice(1)}.`;
	return [`Обложка: ${cover}.`, sentence(details.join('; ')), sentence(state)].join(' ');
}
